import clsx from 'clsx';
import { EyeIcon } from 'lucide-preact';

import style from './style.scss';

const ViewersCount = ({ plain, viewers, className }) => (
  <div className={clsx(className, { [style.viewerCountWrapper]: !plain })}>
    <div className={style.viewerCount}>
      <EyeIcon className="size-[1em]" />
      <span>{viewers}</span>
    </div>
  </div>
);

export default ViewersCount;
